"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BurgerMenuToggle = require("./BurgerMenuToggle");
Object.keys(_BurgerMenuToggle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BurgerMenuToggle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BurgerMenuToggle[key];
    }
  });
});
